<template>
  <div class="online-personnel" :class="{ 'online-personnel--expanded': visible }">
    <button
      type="button"
      class="online-personnel__trigger"
      title="人员列表"
      aria-label="人员列表"
      @dblclick.prevent
      @click="$emit('toggle')"
    >
      <svg
        class="online-personnel__trigger-icon"
        viewBox="0 0 1024 1024"
        aria-hidden="true"
      >
        <!-- eslint-disable-next-line max-len -->
        <path d="M573.00032 219.072c127.808-1.92 234.368 102.912 234.368 230.72a230.208 230.208 0 0 1-85.568 179.328 347.648 347.648 0 0 1 99.648 69.696 342.976 342.976 0 0 1 101.248 235.136 9.216 9.216 0 0 1-9.216 9.472h-64.64a9.216 9.216 0 0 1-9.152-8.896 261.76 261.76 0 0 0-76.928-177.024 261.312 261.312 0 0 0-186.048-77.056 261.376 261.376 0 0 0-186.048 77.056 260.672 260.672 0 0 0-76.928 177.024 9.216 9.216 0 0 1-9.216 8.896h-64.64a9.216 9.216 0 0 1-9.216-9.472 343.808 343.808 0 0 1 101.056-235.136c28.864-28.928 62.592-52.48 99.648-69.696a230.784 230.784 0 0 1 141.632-410.048zM349.96032 20.672a231.04 231.04 0 0 1 202.624 126.784 9.28 9.28 0 0 1-7.232 13.44c-22.08 2.24-43.52 7.232-63.808 14.272a9.216 9.216 0 0 1-10.688-3.712A147.456 147.456 0 0 0 348.16832 103.68a146.88 146.88 0 0 0-107.52 44.672 146.88 146.88 0 0 0-41.92 98.688c-1.28 41.344 14.976 81.28 44.672 110.08 12.352 12.096 26.752 21.888 42.56 28.928 3.84 1.792 5.952 6.016 5.12 10.176-5.12 27.712-6.208 56-3.264 84.032a9.216 9.216 0 0 1-6.976 10.048 260.352 260.352 0 0 0-120.768 68.864A260.736 260.736 0 0 0 83.20832 736.192a9.216 9.216 0 0 1-9.216 8.832H9.28832A9.216 9.216 0 0 1 0.00832 735.552a343.04 343.04 0 0 1 101.248-235.264c28.928-28.928 62.72-52.48 99.84-69.696a230.08 230.08 0 0 1-85.632-179.328c0-127.68 106.56-232.512 234.496-230.528z m225.28 281.472a147.84 147.84 0 0 0-146.112 146.112c-0.64 39.68 15.04 77.952 43.2 105.92a146.368 146.368 0 0 0 104.32 43.2c39.296 0.128 76.864-15.424 104.576-43.2a146.56 146.56 0 0 0 43.2-104.384 146.56 146.56 0 0 0-44.288-105.408 148.48 148.48 0 0 0-104.96-42.24z" />
      </svg>
    </button>

    <aside class="online-personnel__panel" aria-label="人员列表">
      <div class="online-personnel__header">
        <span class="online-personnel__title">人员列表</span>
        <span class="online-personnel__count">在线 {{ onlineCount }}/{{ users.length }}</span>
      </div>
      <div v-if="users.length" class="online-personnel__list">
        <div
          v-for="(person, index) in users"
          :key="person.name + person.maskedPhone + index"
          class="online-personnel__item"
        >
          <div class="online-personnel__identity">
            <span class="online-personnel__name">{{ person.name || '未命名人员' }}</span>
            <span class="online-personnel__phone">{{ person.maskedPhone || '****' }}</span>
          </div>
          <span
            class="online-personnel__status"
            :class="{ 'online-personnel__status--online': person.isInRoom }"
          >
            <i class="online-personnel__dot"></i>
            {{ person.isInRoom ? '在线' : '未进入' }}
          </span>
        </div>
      </div>
      <div v-else class="online-personnel__empty">暂无人员数据</div>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'OnlinePersonnel',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    onlineCount() {
      return this.users.filter((person) => person.isInRoom).length;
    },
  },
};
</script>

<style scoped>
.online-personnel {
  position: fixed;
  top: 180px;
  left: 12px;
  z-index: 1200;
  pointer-events: none;
}

.online-personnel__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(135deg, rgba(30, 115, 172, 0.78), rgba(38, 170, 139, 0.68));
  box-shadow: 0 5px 16px rgba(20, 77, 104, 0.2);
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: auto;
}

.online-personnel__trigger-icon {
  width: 20px;
  height: 20px;
  fill: #fff;
}

.online-personnel__panel {
  position: absolute;
  top: 42px;
  left: 0;
  width: min(300px, calc(100vw - 24px));
  max-height: min(460px, calc(100vh - 246px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 10px;
  color: #effcff;
  background: linear-gradient(145deg, rgba(24, 72, 102, 0.9), rgba(29, 130, 127, 0.84));
  box-shadow: 0 12px 28px rgba(12, 42, 60, 0.28);
  opacity: 0;
  transform: translateX(calc(-100% - 18px));
  transition: opacity 0.25s ease, transform 0.25s ease;
  pointer-events: none;
}

.online-personnel--expanded .online-personnel__panel {
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

.online-personnel__header,
.online-personnel__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.online-personnel__header {
  padding-bottom: 9px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.online-personnel__title { font-size: 14px; font-weight: 700; }
.online-personnel__count { color: rgba(238, 255, 255, 0.78); font-size: 11px; }
.online-personnel__list {
  min-height: 0;
  padding-top: 4px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: rgba(190, 238, 231, 0.62) transparent;
}

.online-personnel__list::-webkit-scrollbar {
  width: 5px;
}

.online-personnel__list::-webkit-scrollbar-track {
  margin: 6px 0;
  background: transparent;
}

.online-personnel__list::-webkit-scrollbar-thumb {
  border: 1px solid rgba(219, 255, 250, 0.32);
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(202, 251, 239, 0.78), rgba(127, 214, 195, 0.58));
}

.online-personnel__list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(223, 255, 247, 0.9), rgba(132, 226, 204, 0.75));
}
.online-personnel__item {
  padding: 9px 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.online-personnel__item:last-child { border-bottom: 0; }
.online-personnel__identity {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}
.online-personnel__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.online-personnel__phone { color: rgba(238, 255, 255, 0.68); font-size: 11px; }
.online-personnel__status {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  color: rgba(238, 255, 255, 0.62);
  font-size: 11px;
}
.online-personnel__status--online { color: #d8ffe7; }
.online-personnel__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #b7c5cb;
}
.online-personnel__status--online .online-personnel__dot {
  background: #7cf0a5;
  box-shadow: 0 0 7px rgba(124, 240, 165, 0.9);
}
.online-personnel__empty {
  padding: 20px 4px 8px;
  color: rgba(238, 255, 255, 0.7);
  text-align: center;
  font-size: 12px;
}

@media (max-width: 480px) {
  .online-personnel { top: 125px; left: 6px; }
  .online-personnel__panel {
    width: min(300px, calc(100vw - 12px));
    max-height: calc(100vh - 185px);
  }
}
</style>
